import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// Not: basename her zaman '/' sabittir; Vite'ın 'base' ayarı (statik asset
// yolu, '/static/') ile SPA route basename'i kasıtlı olarak birbirinden
// bağımsız tutulur — aksi halde Django'nun '/'te servis ettiği rotalar eşleşmez.
const router = createBrowserRouter([MainRoutes, LoginRoutes], { basename: '/' });

export default router;
